module.exports = __webpack_public_path__ + "fonts/SourceHanSansCN-Medium.8cc12491.ttf";